import { firstApplicationData } from './first-application.data';
import {
  intelligentSystemTestingApplicationMeta,
  reinforcementLearningApplicationMeta,
  PageMeta,
  intelligentDataPipelineApplicationMeta,
  automaticDatasetEnhancementApplicationMeta,
} from 'constants/pages';

import { IApplicationData } from 'types/applications';
import { secondApplicationData } from './second-application.data';
import { thirdApplicationData } from './third-application.data';
import { forthApplicationData } from './forth-application.data';

export interface IFullApplicationsData {
  pageMeta: PageMeta;
  data: IApplicationData;
}

export const allApplicationsData: IFullApplicationsData[] = [
  {
    pageMeta: intelligentSystemTestingApplicationMeta,
    data: firstApplicationData,
  },
  {
    pageMeta: intelligentDataPipelineApplicationMeta,
    data: secondApplicationData,
  },
  {
    pageMeta: automaticDatasetEnhancementApplicationMeta,
    data: thirdApplicationData,
  },
  {
    pageMeta: reinforcementLearningApplicationMeta,
    data: forthApplicationData,
  },
];
